import React from 'react';
import PropTypes from 'prop-types';
import iconColorsMap from './colors';

const Web = ({ fill, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    {...props}
  >
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z" />
  </svg>
);
Web.propTypes = { fill: PropTypes.string };
Web.defaultProps = { fill: iconColorsMap.mainicon };

export default Web;
